// extracted by mini-css-extract-plugin
export var blue = "_2y-f";
export var brand = "_2y-b";
export var darkGrey = "_2y-e";
export var disabled = "_2y-4";
export var disabledSubtle = "_2y-5";
export var error = "_2y-6";
export var green = "_2y-g";
export var grey = "_2y-d";
export var icon = "_2y-0";
export var inherit = "_2y-a";
export var lightGrey = "_2y-c";
export var orange = "_2y-i";
export var pink = "_2y-k";
export var primary = "_2y-1";
export var purple = "_2y-l";
export var red = "_2y-j";
export var secondary = "_2y-2";
export var success = "_2y-9";
export var tertiary = "_2y-3";
export var warning = "_2y-7";
export var warningSecondary = "_2y-8";
export var white = "_2y-m";
export var yellow = "_2y-h";